import States from '@/resources/models/states';
import Helpers from '@/shared/helpers/functions';

class UwvDecision {
  constructor (data = {}) {
    this.id = data.id;

    this.employeeCustomerNumber = data.employeeCustomerNumber;
    this.reportOfSicknessId = data.reportOfSicknessId;

    this.decisionType = UwvDecisionTypes[data.uwvDecisionType];
    this.disabilityRate = Helpers.Percentage.parse(data.disabilityRateAsPercentage);

    this.attachments = data.attachments;

    this.startDate = data.startIsoDate;
    this.reportDate = data.reportIsoDate;
    this.benefitEndDate = data.benefitEndIsoDate;
    this.decisionDate = data.decisionIsoDate;

    this.status = States[data.status];
    this.workStockReason = data.workStockReason;

    this.wiaDailyWage = data.wiaDailyWage;
    this.wiaMonthlyWage = data.wiaMonthlyWage;
    this.incomeFromWork = data.incomeFromWork;
  }

  getCreateModel () {
    let result = new FormData();

    result.append('employeeCustomerNumber', this.employeeCustomerNumber);
    result.append('reportOfSicknessId', this.reportOfSicknessId);
    result.append('uwvDecisionType', this.decisionType);

    if (this.disabilityRate != null && this.disabilityRate !== '') {
      result.append('disabilityRateAsPercentage', parseFloat(this.disabilityRate.replace(',', '.')));
    }

    result.append('startIsoDate', this.startDate);

    if (this.benefitEndDate != null && this.benefitEndDate !== '') {
      result.append('benefitEndIsoDate', this.benefitEndDate);
    }

    result.append('decisionIsoDate', this.decisionDate);

    if (this.wiaDailyWage != null && this.wiaDailyWage !== '') {
      result.append('wiaDailyWage', parseFloat(this.wiaDailyWage.replace(',', '.')));
    }
    if (this.wiaMonthlyWage != null && this.wiaMonthlyWage !== '') {
      result.append('wiaMonthlyWage', parseFloat(this.wiaMonthlyWage.replace(',', '.')));
    }
    if (this.incomeFromWork != null && this.incomeFromWork !== '') {
      result.append('incomeFromWork', parseFloat(this.incomeFromWork.replace(',', '.')));
    }

    this.attachments.forEach((file, i) => {
      result.append(`file_${i}`, file);
    });

    return result;
  }
}

const UwvDecisionTypes = {
  WageRelatedBenefit: 'WageRelatedBenefit',
  WageSupplementBenefit: 'WageSupplementBenefit',
  FollowUpBenefit: 'FollowUpBenefit',
  IVABenefit: 'IVABenefit',
  WagePenaly: 'WagePenaly',
  LessThanThirtyFivePercent: 'LessThanThirtyFivePercent',
  Miscellaneous: 'Miscellaneous'
};

export {
  UwvDecision,
  UwvDecisionTypes
};
